import React from "react";
import { TextField, Box } from "@mui/material";

const LabeledTextField = ({ label, value, onChange, disabled = false, multiline = false, rows = 1, labelWidth = "250px" }) => {
  return (
    <Box sx={{
      display: "flex",
      alignItems: multiline ? "flex-start" : "center",
      marginBottom: "16px",
      gap: "16px"
    }}>
      <Box sx={{
        width: labelWidth,
        flexShrink: 0,
        fontSize: "14px",
        fontWeight: 500,
        color: "#1A1E24",
        paddingTop: multiline ? "10px" : "0"
      }}>
        {label}
      </Box>
      <TextField
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        multiline={multiline}
        rows={rows}
        fullWidth
        variant="outlined"
        size="small"
        sx={{
          "& .MuiOutlinedInput-root": {
            fontSize: "14px",
            "& fieldset": {
              borderColor: "#e0e0e0",
            },
            "&:hover fieldset": {
              borderColor: "#1976d2",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#1976d2",
            },
          },
        }}
      />
    </Box>
  );
};

export default LabeledTextField;
